// readPath will take an API-like path and extract information about it

function getOname(path) {
  return path.split("&")[0].split("/").slice(-1)[0].split(".")[0]
}

export default getOname
